import React from 'react';
import { Link } from 'react-router-dom';

function CardItem(props) {
    return (
        <>
            <li className='cards__item'>
                <Link style={{ textDecoration: 'none' }} className='cards__item__link' to={props.path}>
                    <figure className='cards__item__pic-wrap' data-category={props.label}>
                        <img
                            className='cards__item__img'
                            alt='Travel'
                            src={props.src}
                        />
                    </figure>
                    <div className='cards__item__info'>
                        <h6 className='cards__item__header'>{props.header}</h6>
                        <p className='cards__item__text'>{props.text}</p>
                    </div>
                </Link>
            </li>
        </>
    );
}

export default CardItem;